module.exports = __webpack_public_path__ + "5bf8b2afcb1461ef809cb242ab005e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/Sumo.jpg
// module id = 164
// module chunks = 0